import { Config } from '@chegg-wt/core/config'
import { getCookie, Cookies } from '../utils/cookies'
import { requestWithCredentials } from '../utils/api'

/*
  Chegg UI will ultimately provide a hook or some utility to encapsulate all of
  this to hydrate the fanta Header props, so this is just a temporary util for
  getting the necessary data.

  The user interface was taken from
  https://bitbucket.cheggnet.com/projects/CUI/repos/chegg-ui/browse/packages/page-layout/src/Header/UserInterface.ts
  for documentation purposes, but we likely won't need it once Chegg UI exposes
  the necessary utils.
*/

export interface HeaderUser {
  user_id: number
  fname: string
  lname: string
  nickname: string
  email: string
  emailShow: string
  campus_id: number
  schoolId: null
  avatar: string
  avatar_small: string
  hasHomeworkHelpSubscription: null
  subscriptionCatalogId: null
  subscriptionType: string
  fb_id: string
  gender: string
  school_year: string
  phantomPassword: boolean
  uuid: string
  isHighSchoolUser: boolean
}

const JERICHO_CSRF_TOKEN_URL: string = `${Config.cheggEnvUrl}/_ajax/global/init`
const JERICHO_HEADER_USER_URL: string = `${Config.cheggEnvUrl}/_ajax/header/global/user`

export const getJerichoCsrfToken = (): Promise<string> =>
  requestWithCredentials(
    JERICHO_CSRF_TOKEN_URL,
    'GET',
    null,
    'json',
    'application/x-www-form-urlencoded'
  ).then((data) => data.token)

export const getJerichoHeaderUser = (token: string): Promise<HeaderUser | null> => {
  const userCookie = getCookie(Cookies.JerichoSession) || 'loggedOutUser'
  const body = `SU=${encodeURIComponent(userCookie)}&token=${encodeURIComponent(token)}`

  return requestWithCredentials(
    JERICHO_HEADER_USER_URL,
    'POST',
    body,
    'json',
    'application/x-www-form-urlencoded'
  ).then((data) => data.user)
}
